import React from 'react';
import classNames from 'classnames';

import css from './FinancingAvailable.module.css';

// Link to Container Trader's Affirm financing page. Set REACT_APP_AFFIRM_FINANCING_URL in
// Render to your Affirm merchant / prequalification link once Affirm approves the account.
export const AFFIRM_FINANCING_URL =
  process.env.REACT_APP_AFFIRM_FINANCING_URL || 'https://www.affirm.com/how-it-works';

/**
 * "Financing available" note with a link to Affirm.
 *
 * @param {Object} props
 * @param {'inline'|'onDark'} [props.variant] - onDark for the homepage hero
 * @param {boolean} [props.compact] - badge + link only
 */
const FinancingAvailable = props => {
  const { className, variant = 'inline', compact = false } = props;
  const link = (
    <a className={css.link} href={AFFIRM_FINANCING_URL} target="_blank" rel="noopener noreferrer">
      {compact ? 'Financing available with Affirm' : 'Learn about Affirm financing'}
    </a>
  );

  if (compact) {
    return <span className={classNames(css.compact, css[variant], className)}>{link}</span>;
  }

  return (
    <div className={classNames(css.root, css[variant], className)}>
      <span className={css.badge}>Financing available</span>
      <p className={css.text}>Pay over time for your container and delivery. {link}</p>
      <p className={css.fineprint}>Subject to Affirm eligibility and approval.</p>
    </div>
  );
};

export default FinancingAvailable;
